export var Direction;

!function(Direction) {
    Direction.vertical = "vertical", Direction.horizontal = "horizontal";
}(Direction || (Direction = {}));
//# sourceMappingURL=space.js.map
